import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { florenceALConfig } from "./data";

export default function FlorenceALPage() {
  return <CityPageTemplate config={florenceALConfig} />;
}